module.exports = __webpack_public_path__ + "static/jonathan_cai_resume-dc0eae1b044a1d81c6254387312c7c5f.pdf";